export default {"src":"/_next/static/media/BMO.1035836b.svg","height":18,"width":18};